import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

const FocusTrap = ({ opened, onClose, children }) => {
  const modalRef = useRef(null);

  useEffect(() => {
    if (opened) {
      const modalElement = modalRef.current;
      // preventScroll: focusing a root-level popup must not scroll the app behind it
      modalElement.focus({ preventScroll: true });
      //add any focusable HTML element you want to include to this string
      const focusableElements = modalElement.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      const firstElement = focusableElements[0];
      const lastElement = focusableElements[focusableElements.length - 1];

      const handleTabKeyPress = event => {
        if (event.key === 'Tab') {
          if (event.shiftKey && document.activeElement === firstElement) {
            event.preventDefault();
            lastElement.focus({ preventScroll: true });
          } else if (
            !event.shiftKey &&
            document.activeElement === lastElement
          ) {
            event.preventDefault();
            firstElement.focus({ preventScroll: true });
          }
        }
      };

      const handleEscapeKeyPress = event => {
        if (event.key === 'Escape') {
          onClose && onClose();
        }
      };

      modalElement.addEventListener('keydown', handleTabKeyPress);
      modalElement.addEventListener('keydown', handleEscapeKeyPress);

      return () => {
        modalElement.removeEventListener('keydown', handleTabKeyPress);
        modalElement.removeEventListener('keydown', handleEscapeKeyPress);
      };
    }
  }, [opened, onClose]);

  return (
    <div tabIndex={-1} className="focus_trap" ref={modalRef}>
      {children}
    </div>
  );
};

FocusTrap.propTypes = {
  onClose: PropTypes.func,
  opened: PropTypes.bool,
  children: PropTypes.element
};

export default FocusTrap;
